/**
 * Custom Plotly Theme
 * Aquatic color scheme matching the design system
 */

import { Layout, Config } from 'plotly.js';
import { colors } from './colors';
import { fonts } from './typography';

export const plotlyLayout: Partial<Layout> = {
  paper_bgcolor: 'transparent',
  plot_bgcolor: 'rgba(247, 251, 252, 0.5)',
  font: {
    family: fonts.body,
    color: colors.text.primary,
    size: 13,
  },
  colorway: colors.charts.colorway,
  margin: { l: 60, r: 40, t: 40, b: 60 },
  hovermode: 'closest',
  hoverlabel: {
    bgcolor: colors.neutral[800],
    bordercolor: colors.neutral[700],
    font: {
      family: fonts.body,
      color: colors.text.inverse,
      size: 12,
    },
  },
  xaxis: {
    gridcolor: colors.neutral[200],
    gridwidth: 1,
    showgrid: true,
    zeroline: false,
    showline: true,
    linecolor: colors.neutral[300],
    linewidth: 1,
    tickfont: {
      family: fonts.body,
      color: colors.text.secondary,
      size: 11,
    },
    titlefont: {
      family: fonts.body,
      color: colors.text.primary,
      size: 13,
    },
  },
  yaxis: {
    gridcolor: colors.neutral[200],
    gridwidth: 1,
    showgrid: true,
    zeroline: false,
    showline: true,
    linecolor: colors.neutral[300],
    linewidth: 1,
    tickfont: {
      family: fonts.body,
      color: colors.text.secondary,
      size: 11,
    },
    titlefont: {
      family: fonts.body,
      color: colors.text.primary,
      size: 13,
    },
  },
  legend: {
    bgcolor: 'rgba(255, 255, 255, 0.9)',
    bordercolor: colors.neutral[200],
    borderwidth: 1,
    font: {
      family: fonts.body,
      color: colors.text.primary,
      size: 12,
    },
  },
};

export const plotlyConfig: Partial<Config> = {
  displayModeBar: true,
  displaylogo: false,
  modeBarButtonsToRemove: ['lasso2d', 'select2d'],
  toImageButtonOptions: {
    format: 'png',
    filename: 'chart',
    height: 800,
    width: 1200,
    scale: 2,
  },
  responsive: true,
};

// Trace template for line charts
export const lineTraceTemplate = {
  mode: 'lines',
  type: 'scatter' as const,
  line: {
    width: 2,
    shape: 'linear' as const, // Actual values without interpolation
  },
  hovertemplate: '<b>%{fullData.name}</b><br>%{x}<br>%{y}<extra></extra>',
};

// Trace template for bar charts
export const barTraceTemplate = {
  type: 'bar' as const,
  hovertemplate: '<b>%{fullData.name}</b><br>%{x}<br>%{y}<extra></extra>',
};

// Box plot colors
export const boxPlotColors = {
  fillcolor: 'rgba(8, 131, 149, 0.3)',
  line: {
    color: colors.primary.main,
    width: 2,
  },
  marker: {
    color: colors.primary.main,
    size: 4,
  },
};
